import { combineReducers } from "redux";
import { actionTypes } from '../../actions'
import { actions } from "../../actions/Types";
import { RootState } from "../../configureStore";

const { SUCCESS, REQUEST, GET_ORG_DATA,FAILURE,RESET } = actionTypes

const entity = () => {
    const initialState = {
        processTypes: [],
        timeZones: [],
        countries: [],
        currencies: [],
        sectorTypes: [],
        error: null,
    };
    const getOrgDataReducer = (state = initialState, action: actions) => {
        console.log(action,"kkkk")
        switch (action.type) {
            case GET_ORG_DATA[REQUEST]:
                return {};
            case GET_ORG_DATA[SUCCESS]:
                return action.payload;
            case GET_ORG_DATA[FAILURE]:
                return {};
            case GET_ORG_DATA[RESET]:
                return {};
            default:
                return state;
        }
    };
    return combineReducers({
        getOrgDataReducer
    })
}

export default entity

export const getEntity = (state: RootState) => state.entities.entityManagement